import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';

const IconHelp = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8.00781 10.75C8.42197 10.7501 8.75781 11.0858 8.75781 11.5C8.75781 11.9142 8.42197 12.2499 8.00781 12.25H8C7.58579 12.25 7.25 11.9142 7.25 11.5C7.25 11.0858 7.58579 10.75 8 10.75H8.00781ZM6.67969 4.34473C7.18855 4.04569 7.78741 3.93645 8.36914 4.03613C8.95067 4.13595 9.47828 4.43839 9.8584 4.88965C10.2384 5.34111 10.447 5.91281 10.4463 6.50293L10.4385 6.67285C10.363 7.50605 9.7435 8.08094 9.25586 8.41504C8.98229 8.60238 8.71162 8.74172 8.51172 8.83301C8.508 8.83468 8.50365 8.83623 8.5 8.83789V9.83594C8.5 10.1119 8.27595 10.3357 8 10.3359C7.72405 10.3357 7.5 10.1119 7.5 9.83594V8.50293C7.50002 8.28962 7.63534 8.09981 7.83691 8.03027L7.83887 8.0293C7.84095 8.02856 7.8448 8.02715 7.84961 8.02539C7.86045 8.02143 7.87868 8.01473 7.90137 8.00586C7.94707 7.98797 8.01438 7.95997 8.0957 7.92285C8.26061 7.84755 8.47764 7.73652 8.69043 7.59082C9.14357 7.28045 9.44629 6.91051 9.44629 6.50293V6.50195C9.44675 6.14785 9.32177 5.80509 9.09375 5.53418C8.86571 5.26338 8.54911 5.08142 8.2002 5.02148C7.85123 4.96173 7.49178 5.02767 7.18652 5.20703C6.88136 5.38648 6.64879 5.66802 6.53125 6.00195C6.43956 6.26236 6.154 6.39924 5.89355 6.30762C5.63348 6.21578 5.49642 5.93019 5.58789 5.66992C5.78382 5.11328 6.17097 4.64381 6.67969 4.34473Z"
      fill="#FF5600"
    />
  </svg>
);

const IconSupport = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z"
      stroke="#FF5600"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
      stroke="#FF5600"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 5L13.5 2.5M11 11L13.5 13.5M5 11L2.5 13.5M5 5L2.5 2.5" stroke="#FF5600" strokeLinejoin="round" />
  </svg>
);

const IconLive = () => (
  <svg width="27" height="16" viewBox="0 0 27 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0755 7.77252C16.2467 7.87568 16.2467 8.12396 16.0755 8.22712L12.2775 10.5152C12.1006 10.6218 11.8752 10.4944 11.8752 10.2879L11.8752 5.71173C11.8752 5.50525 12.1006 5.37787 12.2775 5.48443L16.0755 7.77252Z"
      fill="#FF5600"
    />
    <circle cx="13.2684" cy="8.00042" r="5.07268" stroke="#FF5600" />
    <path
      d="M19.1219 2.73197C20.7027 4.13601 21.6017 5.94451 21.6565 7.83081C21.7113 9.71711 20.6196 11.8077 19.1219 13.2686"
      stroke="#FF5600"
      strokeLinecap="round"
    />
    <path
      d="M22.0487 0.390839C23.8728 2.4189 24.9101 5.03118 24.9733 7.75583C25.0364 10.4805 23.7768 13.5002 22.0487 15.6104"
      stroke="#FF5600"
      strokeLinecap="round"
    />
    <path
      d="M7.41479 13.268C5.83393 11.864 4.93493 10.0555 4.88018 8.16919C4.82543 6.28289 5.91709 4.1923 7.41479 2.73145"
      stroke="#FF5600"
      strokeLinecap="round"
    />
    <path
      d="M4.48791 15.6101C2.66384 13.5821 1.62654 10.9698 1.56336 8.24514C1.50018 5.52049 2.7598 2.50074 4.48792 0.390625"
      stroke="#FF5600"
      strokeLinecap="round"
    />
  </svg>
);

const IconCommunity = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.333374 12V11.3333C0.333374 9.67648 1.67652 8.33333 3.33337 8.33333C4.99023 8.33333 6.33337 9.67648 6.33337 11.3333V13C6.33337 13.3682 6.0349 13.6667 5.66671 13.6667C5.29852 13.6667 5.00004 13.3682 5.00004 13V10C5.00004 8.34314 6.34319 7 8.00004 7C9.6569 7 11 8.34315 11 10V13C11 13.3682 10.7016 13.6667 10.3334 13.6667C9.96518 13.6667 9.66671 13.3682 9.66671 13V11.3333C9.66671 9.67648 11.0099 8.33333 12.6667 8.33333C14.3236 8.33333 15.6667 9.67648 15.6667 11.3333V12"
      stroke="#FF5600"
    />
    <circle cx="3.33337" cy="4.66699" r="1.5" stroke="#FF5600" />
    <circle cx="8" cy="3.33301" r="1.5" stroke="#FF5600" />
    <circle cx="12.6666" cy="4.66699" r="1.5" stroke="#FF5600" />
  </svg>
);

export const HelpBlocks = () => {
  const translations = useTranslations();

  return (
    <View>
      <Block>
        <BlockIcon>
          <IconHelp />
        </BlockIcon>
        <BlockTitle>{translations.t('site.home.assistance.help.block1.title')}</BlockTitle>
        <BlockText>{translations.t('site.home.assistance.help.block1.text')}</BlockText>
      </Block>

      <Block>
        <BlockIcon>
          <IconSupport />
        </BlockIcon>
        <BlockTitle>{translations.t('site.home.assistance.help.block2.title')}</BlockTitle>
        <BlockText>{translations.t('site.home.assistance.help.block2.text')}</BlockText>
      </Block>

      <Block>
        <BlockIcon>
          <IconLive />
        </BlockIcon>
        <BlockTitle>{translations.t('site.home.assistance.help.block3.title')}</BlockTitle>
        <BlockText>{translations.t('site.home.assistance.help.block3.text')}</BlockText>
      </Block>

      <Block>
        <BlockIcon>
          <IconCommunity />
        </BlockIcon>
        <BlockTitle>{translations.t('site.home.assistance.help.block4.title')}</BlockTitle>
        <BlockText>{translations.t('site.home.assistance.help.block4.text')}</BlockText>
      </Block>
    </View>
  );
};

const View = styled.div`
  margin-bottom: 16px;

  @media ${Points.tablet_portrait} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }

  @media ${Points.laptop_wide} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
const Block = styled.div`
  background-color: ${Colors.beige_100};
  border-radius: 20px;
  padding: 40px;
  position: relative;
  margin-bottom: 15px;

  @media ${Points.tablet_portrait} {
    margin-bottom: 0;
  }
`;
const BlockIcon = styled.div`
  position: absolute;
  top: 17px;
  left: 17px;
`;
const BlockTitle = styled.div`
  font-size: 24px;
  line-height: 1.1;
  color: ${Colors.main_black};
  margin-bottom: 20px;
  font-weight: 500;
`;
const BlockText = styled.div`
  font-size: 18px;
  line-height: 1.3;
  color: ${Colors.main_black};
`;
